module.exports = __webpack_public_path__ + "../resources/images/illustration_search-54f09e7c7f240dab187da9049263ea89.svg";